import React, { useState, useEffect, Suspense, lazy } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { DEFAULT_BOX_SHADOW, PRIMARY_BACKGROUND } from "App/constants/theme";

import { Paper, Grid } from "@material-ui/core";
import { Title } from "App/Component/ui";

import { FormProvider } from "./context/FormContext";
import { getPoListById, RenderListPo } from "./helpers";
import { RESET_STATE_PO_BARANG } from "./ui/DataBarang/helpers";
import { WMS_PBF_PO } from "App/constants";
import { isNull } from "App/utils/helpers";
import Export from "./ui/Export";
import { LoadingBackdrop } from "components/atoms";
import { useDispatchWrapper } from "hooks";

const DataBarang = lazy(() => import("./ui/DataBarang/DataBarang"));
const Perhitungan = lazy(() => import("./ui/Perhitungan/Perhitungan"));
const FormPo = lazy(() => import("./ui/FormPo/FormPo"));

const useStyles = makeStyles({
  root: {
    width: "auto",
  },
  paper: {
    width: "100%",
    margin: "0",
    padding: "1rem 1.5rem",
    backgroundColor: PRIMARY_BACKGROUND,
    boxShadow: DEFAULT_BOX_SHADOW,
  },
  table: {
    width: "100%",
    margin: "0 auto",
    overflow: "auto",
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function PurchaseOrderTransaksiGudang() {
  const classes = useStyles();
  return (
    <Suspense fallback={<LoadingBackdrop />}>
      <FormProvider>
        <div className={classes.root}>
          <Title title={"Purchase Order (PO) Perbekalan Farmasi"} />
          <Paper className={classes.paper}>
            <FormPo />
            <div className='mt-2'></div>
            <RenderContent classes={classes} />
          </Paper>
        </div>

        <Export />
      </FormProvider>
    </Suspense>
  );
}

const RenderContent = ({ classes }) => {
  const [formBarang, setFormBarang] = useState(RESET_STATE_PO_BARANG);
  const [showModalBarang, setShowModalBarang] = useState(false);
  const [listPO, setListPO] = useState([]);
  const { state } = useDispatchWrapper();

  useEffect(() => {
    if (state.wrapper_active_menu === WMS_PBF_PO) {
      setNewDataPoList(state.page_wf_purchase_order?.idpo);
    }
  }, [state.page_wf_purchase_order?.idpo]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewDataPoList = async (idPo) => {
    if (!isNull(idPo)) {
      const res = await getPoListById(idPo);
      if (res.state) {
        setListPO(res.data);
      } else {
        setListPO([]);
      }
    }
  };

  return (
    <>
      <RenderListPo
        classes={classes}
        formBarang={formBarang}
        setFormBarang={setFormBarang}
        showModalBarang={showModalBarang}
        setShowModalBarang={setShowModalBarang}
        listPO={listPO}
        setNewDataPoList={setNewDataPoList}
      />
      <Grid container spacing={2}>
        <Grid item xs={6} sm={6}>
          <DataBarang
            formBarang={formBarang}
            setFormBarang={setFormBarang}
            showModalBarang={showModalBarang}
            setShowModalBarang={setShowModalBarang}
            listPO={listPO}
            setListPO={setListPO}
            setNewDataPoList={setNewDataPoList}
          />
        </Grid>
        <Grid item xs={6} sm={6}>
          <Perhitungan
            setListPO={setListPO}
            listPO={listPO}
            setNewDataPoList={setNewDataPoList}
          />
        </Grid>
      </Grid>
    </>
  );
};
